import { createContext } from 'react';

export const PaymentGoalContext = createContext<GoalFieldsContextValue>({
  fields: {},
  report: () => {},
});
